import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';

/**
 * Track when user attempt to verify email.
 */
export const emailVerificationAttempted = (isValid: boolean, method: string): Promise<void> => {
  return Segment.track('Email Verification Attempted', { is_valid: isValid, method });
};

/**
 * Track when verification email was sent to user.
 */
export const emailVerificationRequest = (): Promise<void> => {
  return Segment.track('Verification Email Sent', {});
};
